import { NewsListItem } from "app/news/interfaces";

export function prepareNewsList(news: NewsListItem[] | undefined): NewsListItem[] | undefined {
    if (news) {
        return news.map((item: any) => {
            let id = item.id;
            if (item.url) {
                const parts = item.url.split("/");
                id = parts[parts.length - 1];
            }

            return {
                ...item,
                id
            };
        });
    }
    return undefined;
}
